import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private auth: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const storeToken = this.auth.getStoreToken();
    const isApiUrl = req.url.startsWith(environment.apiBaseUrl);

    if (storeToken && isApiUrl) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${storeToken}`,
        },
      });
    }
    return next.handle(req);
  }
}
